import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUserContext } from "../Context/UserContext.tsx";
import BrokenLinkDialog from './BrokenLinkDialog.tsx';
import SessionService from '../Services/SessionService.tsx';
import { useLocation } from "react-router-dom";
import { useBrokenLinkDialog } from '../Context/BrokenLinkDialogContext.tsx';

const WildCardRoute = () => {

  const location = useLocation();
  const navigate = useNavigate();
  const [visible, setVisible] = useState(true);
  const { role } = useUserContext();
   
  const pathParts = location.pathname.split("/").filter(Boolean);
  const shareholderId = pathParts[1];  
  const currentFiscalYearId = pathParts[2];  

  const { setThroughWCvisible } = useBrokenLinkDialog();

  useEffect(() => {    
    setThroughWCvisible(true);
  }, []);
 
  const handleRedirect = () => {
    setVisible(false);
    setThroughWCvisible(false);
    if (role?.toLocaleLowerCase() === 'leader' || role?.toLocaleLowerCase() === 'coleader') {
      SessionService.setNavigateTo('LeaderLandingPage');
      navigate('/');
    } 
    else if (role?.toLocaleLowerCase() === 'shareholder') {
      navigate(`/evaluationPlan`);
    } 
    else {
      navigate('/'); 
    }
  };

  return (    
    <BrokenLinkDialog 
     shareholderId={shareholderId}
     currentFiscalYearId={currentFiscalYearId}
     visible={visible}
     onRedirect={handleRedirect}
    />
  );
};

// const IsValidGUid = (guid: string): boolean => {
//   const guidRegex = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
//   return guidRegex.test(guid);
// }

// export { IsValidGUid };

export default WildCardRoute;